import type { OrderAppCtaType } from '@/graphql/orderApp/api';
import type { CountryCode } from '@/graphql/saleor/api';

export function isSmbcAvailable(
  country: CountryCode,
  variantCTA?: OrderAppCtaType,
  amount?: number,
  smbcPaymentMax?: number | null,
  smbcPaymentMin?: number | null,
) {
  return (
    country === 'JP' &&
    amount &&
    variantCTA === 'ORDER' &&
    smbcPaymentMax !== undefined &&
    smbcPaymentMin !== undefined &&
    (smbcPaymentMax === null || amount <= smbcPaymentMax) &&
    (smbcPaymentMin === null || amount >= smbcPaymentMin)
  );
}
